import React from 'react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirmar', 
  cancelText = 'Cancelar',
  type = 'warning' // 'warning', 'danger', 'info', 'success'
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      case 'success':
        return '✅';
      case 'warning':
      default:
        return '⚠️';
    }
  };

  const getTypeClass = () => {
    switch (type) {
      case 'danger':
        return 'confirm-dialog-danger';
      case 'info':
        return 'confirm-dialog-info';
      case 'success':
        return 'confirm-dialog-success';
      case 'warning':
      default:
        return 'confirm-dialog-warning';
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="confirm-dialog-overlay" onClick={onClose}>
      <div className={`confirm-dialog ${getTypeClass()}`} onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          <div className="confirm-dialog-icon">
            {getIcon()}
          </div>
          <h3 className="confirm-dialog-title">{title}</h3>
        </div>
        <div className="confirm-dialog-body">
          <p className="confirm-dialog-message">{message}</p>
        </div>
        <div className="confirm-dialog-footer">
          <button 
            className="btn btn-secondary confirm-dialog-cancel"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button 
            className={`btn confirm-dialog-confirm ${
              type === 'danger' ? 'btn-danger' : 
              type === 'success' ? 'btn-success' : 
              'btn-primary'
            }`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

